import timezones from 'timezones-list';

export function checkTimeZone(value) {
  return timezones.find(x => x.name === value)?.name 
        ?? "(GMT+00:00) London, Birmingham, Liverpool, Sheffield, Bristol"
}

